'use strict';

/**
 * @ngdoc service
 * @name webAgro1App.VisitaCampoService
 * @description
 * # VisitaCampoService
 * Factory in the webAgro1App.
 */
angular.module('webAgro1App').factory('VisitaCampoService', function($q, OperacoesService, OperacoesDadosService,
    MapaPropriedadeService, TrackingService, MapaService) {

  var digestObjectsImages = function(data, keysTypesOperations) {
    var isValidKeysTypesOperations = keysTypesOperations && keysTypesOperations.length > 0;
    for (var i = data.length-1; i >= 0; i--) {
      data[i].images = [];
      var keysNameStatus = Object.keys(TYPES_STATUS_OPERATIONS);
      for (var keyStatus = keysNameStatus.length-1; keyStatus >= 0; keyStatus--) {
        var statusName = keysNameStatus[keyStatus];
        var alerts = data[i][statusName];
        if (alerts) {
          for (var k = alerts.length-1; k >= 0; k--) {
            var typeStr = String(alerts[k].tipo || alerts[k]).toLowerCase();
            if ((isValidKeysTypesOperations && keysTypesOperations.indexOf(typeStr) >= 0) || !isValidKeysTypesOperations) {
              var type = TYPES_DESCRIPTIONS_OPERATIONS[typeStr];
              data[i].images.push({
                url: OperacoesDadosService.getIconAlert(typeStr, statusName),
                type: typeStr,
                status: statusName,
                isGeneral: type.isGeneral,
                description: type.description,
                hint: alerts[k].hint
              });
            }
          }
        }
      }
    }
    return data;
  };

  return {
    getGlebasAlerts: function(filters, keysTypesOperations) {
      var deferred = $q.defer();
      OperacoesService.alertas(filters).catch(deferred.reject).then(function(result) {
        var data = digestObjectsImages(result.data, keysTypesOperations);
        deferred.resolve(data);
      });

      return deferred.promise;
    },

    getHistoryGleba: function(filters) {
      var deferred = $q.defer();
      OperacoesService.getHistoryGleba(filters).catch(deferred.reject).then(function(data){
        data = digestObjectsImages(data);
        deferred.resolve(data);
      });

      return deferred.promise;
    },

    getOperationsDayGleba: function(filters) {
      var deferred = $q.defer();
      var promises = [];
      var result = {};

      promises.push(OperacoesService.getOperationsDayGleba(filters));
      promises.push(TrackingService.users(filters));

      $q.all(promises).then(function(data){
        result = {
          operations: {
            data: (data[0].data.length > 0) ? data[0].data : [],
            markers: OperacoesDadosService.getMarkersOperationsDayGleba(data[0].data)
          },
          trackings: {
            users: (data[1].data.length > 0) ? data[1].data : []
          }
        };
        result.operations.groups = OperacoesDadosService.getOperationsGroupFromMarkers(result.operations.markers);
        deferred.resolve(result);
      }, deferred.reject);

      return deferred.promise;
    },

    newGetTrackingsDayGleba: function(filters) {
      var deferred = $q.defer();
      var trackings = [];

      TrackingService.listForGoogleMaps(filters).then(function(data) {
        trackings = MapaService.setIconPolylines(data, filters.cor);
        deferred.resolve(trackings);
      }, deferred.reject);

      return deferred.promise;
    }
  };
});
